import { db } from "../lib/firebaseApp";
import {
    doc,
    deleteDoc,
    getDocs,
    setDoc,
    collection,
    addDoc,
    serverTimestamp,
    getDoc,
    query,
    where
} from "firebase/firestore";

import { f_import_property_array, f_recursive_delete } from "./fbFunctions";






// ------------------------------------------------------------------------
export const add_Property = async (user_id, event_id, data, cb_error) => {
    try {
        const docRef = await addDoc(collection(db, "EVENTS", event_id, "PROPERTYS"), {
            ...data,
            createTimestamp: serverTimestamp(),
            createBy: user_id
        })
        return (docRef.id)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> add_Property:\n", error)
        }
        return (undefined)
    }
}


// ------------------------------------------------------------------------
export const edit_Property = async (user_id, event_id, property_id, data, cb_error) => {
    try {
        const docRef = await setDoc(doc(db, "EVENTS", event_id, "PROPERTYS", property_id), {
            ...data,
            id: property_id,
            updateTimestamp: serverTimestamp(),
            lastUpdateBy: user_id
        })

        return (docRef)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> edit_Property:\n", error)
        }
        return (undefined)
    }
}

// ------------------------------------------------------------------------
export const delete_Property = async (event_id, property_id, cb_error) => {
    try {
        const docSnap = await (getDoc(doc(db, "EVENTS", event_id, "PROPERTYS", property_id)))
        if (docSnap.exists()) {
            await deleteDoc(doc(db, "EVENTS", event_id, "PROPERTYS", property_id));
            return (true)
        } else {
            return (false)
        }
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> delete_Property:\n", error)
        }
        return (undefined)
    }
}

// ------------------------------------------------------------------------
export const get_Property_byID = async (event_id, property_id, cb_error) => {
    try {
        const docSnap = await (getDoc(doc(db, "EVENTS", event_id, "PROPERTYS", property_id)))
        if (docSnap.exists()) {
            const data = docSnap.data()
            const doc = {
                ...data,
                id: docSnap.id,
            }
            return (doc)
        } else {
            return (undefined)
        }
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_Property_byID:\n", error)
        }
        return (undefined)
    }
}

// ------------------------------------------------------------------------
export const get_Property_list = async (event_id, property_type, cb_error) => {
    try {
        const property_list = []
        let q = query(collection(db, "EVENTS", event_id, "PROPERTYS"))
        if (property_type != null) q = query(q, where("property_type", "==", property_type))

        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            const property_data = {
                ...data,
                id: doc.id,
            }
            //DEBUG: console.log(doc.id, " => ", property_data);
            property_list.push(property_data)
        });
        return (property_list)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_Property_list:\n", error)
        }
        return ([])
    }
}



// ----------------------------------------------------------------------------


/**
 * importa, nell'evento indicato, la lista delle vacche (convertendo i parametri DATA)
 * 
 * @param {string} event_id - id evento
 * @param {list} property_array - list dei dati delle vacche da importare
 * @param {list} date_key_list - lista dei nomi dei parametri che sono DATE e che quindi vanno convertiti in timestamp in firebase
 * @returns 
 */
export const import_propertys = async (event_id, property_array, date_key_list) => {
    console.log("import_propertys:\n\t", event_id, "\n", property_array, "\n", date_key_list)

    const res = await f_import_property_array({ event_id, property_array, date_key_list })
        .then((result) => {
            // Read result of the Cloud Function.
            /** @type {any} */
            const data = result.data;
            const retValue = data.retval;
            return retValue
        })
        .catch((error) => {
            // Getting the Error details.
            const code = error.code;
            const message = error.message;
            const details = error.details;
            console.error("Error in import_propertys cloud function\nError [", code, "]: \n", message, "\n", details)
            return []
        });

    return res
}



// ----------------------------------------------------------------------------
/**
 * Cancella la collection PROPERTYS e tutti documenti cow al suo interno
 * 
 * @param {string} event_id - id dell'evento da cui cancellare la collection 
 * @returns 
 */
export const clear_all_propertys = async (event_id) => {
    console.log("clear_all_propertys ", event_id)
    
    const path = "EVENTS/" + event_id + "/PROPERTYS"
    const res = await f_recursive_delete({ path})
        .then((result) => {
            // Read result of the Cloud Function.
            /** @type {any} */
            const data = result.data;
            return data.path;
        })
        .catch((error) => {
            // Getting the Error details.
            const code = error.code;
            const message = error.message;
            const details = error.details;
            console.error("Error in clear_all_propertys cloud function\nError [", code, "]: \n", message, "\n", details)
            return undefined
        });

    return res
}